module.exports = __webpack_public_path__ + "static/img/111.9d2a2af.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/111.png
// module id = 497
// module chunks = 3